import { EndpointContract } from '@ublend-npm/aula-schema';
import { GET_HOME_SPACES } from '../../constants/endpoints';
import { HomeSpaceApiItem } from '../../types/state';
import request from '../request';

export type GetHomeSpacesResponse = {
  homeSpaces: HomeSpaceApiItem[];
  nextCursor: string | null;
};

type GetHomeSpacesContract = EndpointContract & {
  query: {
    limit?: number;
    cursor?: string | null;
    includeArchived?: boolean;
  };
  responseBody: GetHomeSpacesResponse;
};

type GetHomeSpacesParams = {
  limit?: number;
  cursor?: string | null;
  includeArchived?: boolean;
};

const getHomeSpaces = async ({
  limit = 20,
  cursor,
  includeArchived = false,
}: GetHomeSpacesParams = {}): Promise<GetHomeSpacesResponse> => {
  const { data, status } = await request<GetHomeSpacesContract>({
    method: 'get',
    url: GET_HOME_SPACES({ limit, cursor, includeArchived }),
  });

  if (status !== 200) {
    throw new Error(`Home spaces fetch non 200: ${status}`);
  }

  return data;
};

export default getHomeSpaces;
